const baseVariations = [
  { key: 'normal', instruction: 'Sign at a natural pace.' },
  { key: 'quick', instruction: 'Sign quickly.' },
  { key: 'slow', instruction: 'Sign slowly and clearly.' }
];

const angryVariation = { 
  key: 'angry', 
  instruction: 'Sign as if you are angry.' 
};

const excitedVariation = { 
  key: 'excited', 
  instruction: 'Sign with excitement.' 
};

const concernedVariation = { 
  key: 'concerned', 
  instruction: 'Sign as if you are concerned.' 
};

const unenthusiasticVariation = { 
  key: 'unenthusiastic', 
  instruction: 'Sign without much energy or enthusiasm.' 
};

const enthusiasticVariation = { 
  key: 'enthusiastic', 
  instruction: 'Sign with great enthusiasm and energy.' 
};

const embarrassedVariation = { 
  key: 'embarrassed', 
  instruction: 'Sign as if you are embarrassed.' 
};

const proudVariation = { 
  key: 'proud', 
  instruction: 'Sign with pride and confidence.' 
};

// Hard-coded with sequential IDs
const phraseSets = [
  { 
    id: 'phrase1',
    text: 'What\'s your name?',
    variations: [...baseVariations, angryVariation, excitedVariation, concernedVariation],
    signs: ['you', 'name', 'what']
  },

  { 
    id: 'phrase2',
    text: 'Do you both have the same name?',
    variations: baseVariations,
    signs: ['two-of-you', 'have', 'same', 'name']
  },

  { 
    id: 'phrase3',
    text: 'Who\'s Jeff?',
    variations: [...baseVariations, angryVariation, excitedVariation, concernedVariation],
    signs: ['#JEFF', 'who']
  },

  {
    id: 'phrase4',
    text: 'Are these two shapes the same or different?',
    variations: baseVariations,
    signs: ['shape', 'triangle-shape', 'circle-shape', 'same', 'different', 'which']
  },

  { 
    id: 'phrase5',
    text: 'When I was growing up I enjoyed cycling',
    variations: baseVariations,
    signs: ['sometime_in_the_past', 'me', 'grow-up', 'me', 'leisure', 'cycling']
  },

  {
    id: 'phrase6',
    text: 'I speak English and Spanish',
    variations: [...baseVariations, excitedVariation],
    signs: ['me', 'speak', 'both', 'english', 'spanish']
  },

  { 
    id: 'phrase7',
    text: 'I\'m deaf',
    variations: [...baseVariations, angryVariation, excitedVariation, concernedVariation],
    signs: ['me', 'deaf']
  },

  { 
    id: 'phrase8',
    text: 'You\'re hearing',
    variations: [...baseVariations, angryVariation, excitedVariation, concernedVariation],
    signs: ['you', 'hearing']
  },

  { 
    id: 'phrase9',
    text: 'In highschool I learned French for 3 years',
    variations: [...baseVariations, unenthusiasticVariation, enthusiasticVariation],
    signs: ['past', 'high-school', 'me', 'learn', 'french', '3', 'year']
  },

  { 
    id: 'phrase10',
    text: 'I\'m currently learning Spanish',
    variations: [...baseVariations, unenthusiasticVariation, enthusiasticVariation],
    signs: ['presently', 'me', 'learn', 'learn', 'spanish']
  },

  { 
    id: 'phrase11',
    text: 'ASL is very hard',
    variations: [...baseVariations, unenthusiasticVariation, enthusiasticVariation, angryVariation, concernedVariation],
    signs: ['#ASL', 'wow', 'hard']
  },

  { 
    id: 'phrase12',
    text: 'English is kind of easy',
    variations: [...baseVariations, unenthusiasticVariation, enthusiasticVariation, concernedVariation],
    signs: ['english', 'kind-of', 'easy']
  },

  { 
    id: 'phrase13',
    text: 'Who is the man that over there wearing a blue shirt?',
    variations: [...baseVariations, angryVariation, excitedVariation, concernedVariation],
    signs: ['male', 'over-there', 'blue', 'shirt', 'who']
  },

  { 
    id: 'phrase14',
    text: 'I have 25 pants',
    variations: [...baseVariations, embarrassedVariation, proudVariation],
    signs: ['me', 'have', '25', 'pants']
  },

  { 
    id: 'phrase15',
    text: 'She hates coffee',
    variations: [...baseVariations, excitedVariation, angryVariation, concernedVariation],
    signs: ['girl', 'he_she_they_right-side', 'detest', 'coffee']
  },

  { 
    id: 'phrase16',
    text: 'He really likes chocolate',
    variations: [...baseVariations, excitedVariation, angryVariation, concernedVariation],
    signs: ['boy', 'he_she_they_right-side', 'kiss-fist', 'chocolate']
  },

  { 
    id: 'phrase17',
    text: 'Blue is his favourite colour',
    variations: [...baseVariations, excitedVariation, angryVariation, concernedVariation],
    signs: ['blue', 'his_her_their_right-side', 'favorite', 'colour']
  },

  { 
    id: 'phrase18',
    text: 'I won the game',
    variations: [...baseVariations, excitedVariation],
    signs: ['game', 'me', 'win']
  },

  { 
    id: 'phrase19',
    text: 'My dad lost the game',
    variations: [...baseVariations, excitedVariation, angryVariation, concernedVariation, unenthusiasticVariation],
    signs: ['my', 'father', 'lose', 'his_her_their_right-side', 'game']
  },

  { 
    id: 'phrase20',
    text: 'I will go to Gallaudet University',
    variations: [...baseVariations, excitedVariation],
    signs: ['me', 'future', 'go-someplace', 'gallaudet']
  },

  { 
    id: 'phrase21',
    text: 'Who\'s here?',
    variations: [...baseVariations, excitedVariation, angryVariation, concernedVariation, unenthusiasticVariation],
    signs: ['who', 'here']
  },

  { 
    id: 'phrase22',
    text: 'Yes, I like you',
    variations: [...baseVariations, excitedVariation, concernedVariation],
    signs: ['yes', 'me', 'like', 'you']
  },

  { 
    id: 'phrase23',
    text: 'No, I don\'t like you',
    variations: [...baseVariations, angryVariation, concernedVariation],
    signs: ['no', 'me', 'not', 'like', 'you']
  },

  { 
    id: 'phrase24',
    text: 'Oh I see, thank you for letting me know',
    variations: baseVariations,
    signs: ['oh-i-see', 'thanks', 'tell_you-to-me']
  },

  { 
    id: 'phrase25',
    text: 'Good morning',
    variations: [...baseVariations, excitedVariation, unenthusiasticVariation],
    signs: ['good', 'morning']
  },

  { 
    id: 'phrase26',
    text: 'I can\'t find my car',
    variations: [...baseVariations, angryVariation, concernedVariation],
    signs: ['me', 'cant', 'find', 'my', 'car']
  },

  { 
    id: 'phrase27',
    text: 'I\'m tired',
    variations: [...baseVariations, angryVariation, concernedVariation],
    signs: ['me', 'tired']
  },

  { 
    id: 'phrase28',
    text: 'My mom\'s sick',
    variations: [...baseVariations, angryVariation, concernedVariation],
    signs: ['mother', 'sick']
  },

  { 
    id: 'phrase29',
    text: 'I don\'t have time',
    variations: [...baseVariations, angryVariation, concernedVariation, enthusiasticVariation],
    signs: ['me', 'none', 'time']
  },

  { 
    id: 'phrase30',
    text: 'I live in Vancouver near the skytrain',
    variations: [...baseVariations, excitedVariation, angryVariation],
    signs: ['me', 'live', 'over-there', 'Vancouver', 'near', 'skytrain']
  },

  { 
    id: 'phrase31',
    text: 'Do you live here in Burnaby?',
    variations: [...baseVariations, excitedVariation, concernedVariation],
    signs: ['you', 'live', 'here', 'Burnaby']
  },

  { 
    id: 'phrase32',
    text: 'Vancouver is a great city',
    variations: [...baseVariations, excitedVariation],
    signs: ['Vancouver', 'wow', 'wonderful', 'city']
  },

  { 
    id: 'phrase33',
    text: 'What are you doing for Christmas? I\'m going skiing with my family',
    variations: baseVariations,
    signs: ['christmas', 'you', 'do_or_did', 'what', 'me', 'family', 'go-someplace-v2', 'skiing']
  },

  { 
    id: 'phrase34',
    text: 'Tomorrow I\'m going to my mother\'s birthday party',
    variations: [...baseVariations, excitedVariation, angryVariation],
    signs: ['tomorrow', 'me', 'go-someplace', 'my', 'mother', 'birthday', 'party']
  },

  { 
    id: 'phrase35',
    text: 'This Friday my friend and I are going shopping and to the movies.',
    variations: baseVariations,
    signs: ['this-v2', 'friday', 'me', 'friend', 'two-of-us', 'leave_for', 'shopping', 'and', 'movie']
  },

  { 
    id: 'phrase36',
    text: 'Last week on Wednesday I stayed home to clean the house then watched tv',
    variations: baseVariations,
    signs: ['last_week', 'wednesday', 'me', 'stay-1h', 'home', 'clean', 'house', 'then', 'watch', '#TV']
  },

  { 
    id: 'phrase37',
    text: 'My friend Jane told Jeff he\'s cute',
    variations: [...baseVariations, angryVariation, concernedVariation, excitedVariation],
    signs: ['my', 'friend', '#JANE', 'tell_right-to-left', '#JEFF', 'he_she_they_left-side', 'cute']
  },

  { 
    id: 'phrase38',
    text: 'My dad showed your mom his car',
    variations: [...baseVariations, angryVariation, concernedVariation, excitedVariation],
    signs: ['my', 'father', 'show_right-to-left', 'your', 'mother', 'his_her_their_right-side', 'car']
  },

  { 
    id: 'phrase39',
    text: 'I\'ve cleaned the house. I haven\'t finished my work.',
    variations: [...baseVariations, angryVariation, concernedVariation],
    signs: ['me', 'finish', 'clean', 'house', 'me', 'not yet', 'finish', 'work']
  },

  { 
    id: 'phrase40',
    text: 'Sorry I won\'t be able to. I have to drop off my friend home.',
    variations: [...baseVariations, angryVariation, concernedVariation],
    signs: ['sorry', 'me', 'cant', 'me', 'have_to', 'drop off', 'my', 'friend', 'home']
  }
];

export { phraseSets, baseVariations };